var render = function render(){var _vm=this,_c=_vm._self._c;return _c('comments-component',{attrs:{"object":_vm.object,"canAddComment":_vm.canAddComment,"closeCommentForm":_vm.closeCommentForm},on:{"onCommentsChanged":_vm.onCommentsChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }